import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9.5,7l5,5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14.5,7l-5,5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "BookX";
const BookX = memo(themed(Icon));
export {
  BookX
};
//# sourceMappingURL=book-x.js.map
